import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { StoreService } from '../../services/store.service';
import { ToolsService } from '../../services/tools.service';
import { ShoppingCart, ShoppingCartProduct } from '../../models/models';
import { pages } from '../../alv-enums';
import { DataService } from 'src/app/services/data.service';
import { Utility } from 'src/app/common/utility';
import { FeeDetail, TransactionSummary } from 'src/app/models/transaction-summary';

@Component({
  selector: 'cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {
  @ViewChild('removeConfirmLink') removeConfirmLink: ElementRef;

  @Input() private currentPage: pages;
  @Input() public registerId: number;

  @Output() private pageChange = new EventEmitter<pages>();
  @Output() update = new EventEmitter();

  private tempProduct: any;
  private apiBaseUrl: string;
  private feeDetails: FeeDetail[];

  /** This is here to allow the html code to access the pages enum. */
  public pagesEnum: any;

  constructor(public storeService: StoreService
    , private toolsService: ToolsService
    , private dataService: DataService
  ) {
    this.pagesEnum = pages;
    this.apiBaseUrl = `${window.location.origin}`;
  }

  ngOnInit() {
  }

  changeProductQty(product: ShoppingCartProduct, qtyAdj: number) {
    const self = this;

    if ((product.quantity) > 1 || (qtyAdj > 0)) {
      product.quantity += qtyAdj;
    }
  }

  get productsGroupedBySession(): any {
    const self = this;
    return self.storeService.shoppingCart.products.reduce(function (res, value) {
      if (!res[value.productId + (value.timeSlot && (value.timeSlot.startDateTimeStr + value.timeSlot.endDateTimeStr))]) {
        res[value.productId + (value.timeSlot && (value.timeSlot.startDateTimeStr + value.timeSlot.endDateTimeStr))] =
          Object.assign({}, value) // clone so that grouping does not affect the actual data structure
      }
      res[value.productId + (value.timeSlot && (value.timeSlot.startDateTimeStr + value.timeSlot.endDateTimeStr))].quantity += value.quantity;
      let products = [];
      for (var index in res) {
        products.push(res[index])
      }
      return products;
    }, {});

  }

  removeProduct(product: ShoppingCartProduct) {
    const self = this;

    self.tempProduct = product;

    if (self.storeService.shoppingCart.products.length === 1 && self.currentPage === pages.ReviewOrder) {
      self.removeConfirmLink.nativeElement.click();
    } else {
      self.removeProductFuction();
    }
  }

  async clearCart() {
    const self = this;
    if (self.currentPage === pages.ReviewOrder) {
      self.removeConfirmLink.nativeElement.click();
    } else {

      await self.removeLastProduct();
    }
  }

  async removeLastProduct() {
    const self = this;
    await Utility.clearSessionCart(self.storeService, self.dataService, self.toolsService);
    self.pageChange.emit(pages.Order);
    self.toolsService.showSuccess('Your cart has been cleared.');
    self.storeService.shoppingCart.products = [];
    window.scroll(0, 0)
  }

  async removeProductFuction() {
    const self = this;

    const product: ShoppingCartProduct = self.tempProduct;
    if (product.isSessionProduct) {
      await self.deleteProductsFromCart(product);
    }

    this.storeService.shoppingCart.transactionFees = null; // Reset transaction fees

    self.storeService.shoppingCart.products = self.storeService.shoppingCart.products.filter(x => x !== product);
    self.storeService.shoppingCart.subTotal = self.storeService.shoppingCart.subTotal;
    self.storeService.shoppingCart.total = self.storeService.shoppingCart.total;
    self.storeService.shoppingCart.taxTotal = self.storeService.shoppingCart.taxTotal;

    // Re-Calculate the transaction fees estimate
    const cartData = {
      registerId: this.registerId,
      paymentType: null,
      cartSubTotal: self.storeService.shoppingCart.subTotal,  // Get from cart state
      cartTaxTotal: self.storeService.shoppingCart.taxTotal,
      includeTaxInFeeCalculation: true,
      products: self.storeService.shoppingCart.products
    };

    const response = await fetch(`${this.apiBaseUrl}/KioskApi/api/ShoppingCart/EstimateTransactionFees`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cartData)
    });

    const result = await response.json();
    this.storeService.shoppingCart.transactionFees = result.data as TransactionSummary;
    this.feeDetails = result.data.feeDetails as FeeDetail[];

    // Assign the transaction fees to the shopping cart
    this.storeService.shoppingCart.transactionFees = new TransactionSummary({
      baseSubTotal: result.data.baseSubTotal,
      baseTaxTotal: result.data.baseTaxTotal,
      transactionFee: result.data.transactionFee,
      transactionFeeTaxAmount: result.data.transactionFeeTaxAmount,
      subTotal: result.data.subTotal,
      taxTotal: result.data.taxTotal,
      grandTotal: result.data.grandTotal,
      feeDetails: result.data.feeDetails || []
    });
    // -- end re-calculate
  }

  duration(startDateTime, endTime): number {
    return Math.floor((Math.abs((new Date(endTime).getTime() -
      new Date(startDateTime).getTime())) / 1000) / 60);
  }

  async deleteProductsFromCart(product: ShoppingCartProduct) {
    const self = this;

    let postData = {
      productGuid: product.productGuid,
      productType: product.productType,
      isArcadeProd: product.arcadeProduct ? true : false,
      orderId: self.storeService.shoppingCart.orderId,
      orderDetaildId: product.shoppingCartProductId
    }
    await self.dataService.post<any>(`/ShoppingCart/DeleteCartProduct_EmployeeCart`, postData)
      .then(response => {
        self.toolsService.ProcessHttpResponse(response, () => {
          if (!response.succeeded) {
            self.toolsService.showError("Failed to empty the Cart");
          }
        });
      });
  }
}
